import { Button, useDisclosure } from '@chakra-ui/react';
import React from 'react';

import { MarkAsNotifiedModal } from './MarkAsNotifiedModal';

export const MarkAsNotifiedButton = ({
  invoicePaymentInKindItemId,
}: {
  invoicePaymentInKindItemId: string;
}) => {
  const modalControls = useDisclosure();

  return (
    <>
      <Button onClick={modalControls.onOpen} variant="secondary">
        Mark Notified
      </Button>
      <MarkAsNotifiedModal
        modalControls={modalControls}
        invoicePaymentInKindItemId={invoicePaymentInKindItemId}
      />
    </>
  );
};
